export var ComponentViewerError;
(function (ComponentViewerError) {
    ComponentViewerError["OfflineRestricted"] = "OfflineRestricted";
    ComponentViewerError["MissingUrl"] = "MissingUrl";
})(ComponentViewerError || (ComponentViewerError = {}));
